import { render } from "./DetailSerie.vue?vue&type=template&id=a7b76b60&scoped=true"
import script from "./DetailSerie.vue?vue&type=script&lang=js"
export * from "./DetailSerie.vue?vue&type=script&lang=js"

import "./DetailSerie.vue?vue&type=style&index=0&id=a7b76b60&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b76b60"]])

export default __exports__